var path = '/client/common/modules/abstract-picker/views/partials/media_to_delete/media-picker-object.html';
var html = "";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;